/**
 * Watch for changes in the cell phone and validate it against the library.
 */
App.directive('popDontMatch', [function() {
    return {
        require: 'ngModel',
        link: function(scope, elem, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            /**
             * Specifically watch for changes in the input.
             */
            scope.$watch(attrs.ngModel, function() {
                var value = elem.val().trim(),
                    isValid = true;

                if (value == attrs.popDontMatch) {
					void 0;
                    isValid = false;
				}

                ngModel.$setValidity('dontmatch', isValid);
            });

        }
    }
}]);
